import { Avatar, Badge, ListItem, ListItemIcon, ListItemText } from "@/components/ui";
import { useAppDispatch, useAppSelector } from "@/config/store";
import { IEdoChatParticipation } from "@/shared/model/edo-chat-participation.model";
import { EdoChatType } from "@/shared/model/enumerations/edo-chat-type.model";
import { ChatState, setSelectedParticipation } from "@/shared/reducers/chat.reducer";
import { User, Users } from "lucide-react";
import axios from "axios";
import { useEffect, useState } from "react";
import { translate } from "react-jhipster";

interface ChatParticipationProps {
  participation: IEdoChatParticipation;
  onOpen: (participation: IEdoChatParticipation) => void;
}

const ChatParticipation = (props: ChatParticipationProps) => {
  const dispatch = useAppDispatch();
  const { selectedParticipation } = useAppSelector<ChatState>(state => state.chat);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState<number>(0);

  const { participation, onOpen } = props;

  const selected = selectedParticipation?.id === participation.id;


  const getUnreadMessagesCount = async () => {
    const response = await axios.get(
      `/chat-participations/${participation.id}/messages/unseen/count`
    );
    setUnreadMessagesCount(response.data.count);
  };


  useEffect(() => {
    if (participation) {
      getUnreadMessagesCount();
    }
  }, [participation]);
  
  const handleOpen = () => {
    dispatch(setSelectedParticipation(participation));
    onOpen(participation);
  };


  // const handleOnSelect = async () => {
  //   await checkAllChatMessages(partecipazione.chat.id);
  //   getUnreadMessagesCount();
  // }



  return (
    <ListItem
      className={`flex cursor-pointer items-center gap-3 px-4 py-3 transition-colors hover:bg-primary/10 ${selected ? 'bg-primary/10 dark:bg-primary/20' : ''}`}
      onClick={handleOpen}
    >
      <ListItemIcon>
        <Avatar className="h-10 w-10">
          {participation.chat.type === EdoChatType.CHAT ? (
            <User className="h-5 w-5" />
          ) : (
            <Users className="h-5 w-5" />
          )}
        </Avatar>
      </ListItemIcon>
      <div className="min-w-0 flex-1">
        <ListItemText
          primary={
            participation.chat.type === EdoChatType.CHAT
              ? participation.title
              : participation.chat.title
          }
          secondary={translate(
            "edocendoApp.EdoChatType." + participation.chat.type
          )}
        />
      </div>
      {unreadMessagesCount > 0 && !selected ? (
        <Badge variant="secondary" className="text-xs">
          {unreadMessagesCount}
        </Badge>
      ) : null}
    </ListItem>
  );
};

export default ChatParticipation;
